import React, {FunctionComponent} from 'react';
import {ILocation} from '../../../models/event/Location';
import Location from '../../event/Location';
import OldUrls from '../../../models/utils/OldUrls';
import UILink from '../../../ui/UILink';
import Tooltip from '../../../ui/Tooltip';
import IconConfirmed from '../../icon/IconConfirmed';
import Schedule, {ISchedule} from '../../../models/event/Schedule';
import ScheduleFormatter from '../../../models/formatter/ScheduleFormatter';
import startsIn from './StartsIn';
import Badge from '../../../ui/Badge';

type CalendarRowProps = {
  id: number
  title: string
  schedule: ISchedule
  location: ILocation
  students: number
  soldTickets: number
}

const CalendarRow: FunctionComponent<CalendarRowProps> = ({
  id, title, schedule, location, students, soldTickets,
}) => {
  const eventSchedule = new Schedule(schedule);
  const date = ScheduleFormatter.format('en-GB', eventSchedule, 'interval');
  return (
    <>
      <div className="col-span-7 grid grid-cols-12">
        <div>
          <Tooltip content="Confirmed" label={`confirmed_${id}`}><IconConfirmed className="text-green"/></Tooltip>
        </div>
        <div className="col-span-11">
          <div className="pb-2"><UILink href={OldUrls.event(id)}>{title}</UILink></div>
          <div className="pb-2">
            <Location online={location.online} country={location.country} city={location.city}/>
          </div>
        </div>
      </div>
      <div className="col-span-5">
        <div className="grid grid-cols-7">
          <div className="col-span-4">
            {date}
            <div className="mt-1"><Badge id="startsIn" type="gray" className="font-sm" caption={startsIn(eventSchedule.start)}/></div>
          </div>
          <div className="text-right">{students}</div>
          <div className="text-right">{soldTickets}</div>
        </div>
      </div>
    </>
  );
};

export default CalendarRow;
